import * as P from "./Proucts-list-styles";
import { useRouter } from "next/router";
import { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import Breadcrumb2 from "../../layout/Breadcrumb2";
import { fetchProduct } from "../../../redux/action/product";
import {
  updateProductCategory,
  updateProductFilters,
} from "../../../redux/action/productFiltersAction";
import SingleProduct from "../../ecommerce/singleProduct/SingleProduct";
import Tags from "../../ecommerce/Filter/Tags";
import CategorySlider from "../../sliders/Category";
import Link from "next/link";
import { isLoading, isLoaded } from "../../../redux/action/loading";
import Layout from "../../layout/Layout";
import TableTypeList from "./TableTypeList";
import { getCookie } from "../../../common/auth";
import RequestLoginModal from "../../elements/requestLoginModal";
import modalOverflowHook from "../../../common/modalOverflowHook";
import NoticePagination from "../../csboard/notice/notice-pagination";
import { useBannerQuery } from "@hook/useBannerQuery";
import { usePaginationHandlerModified } from "@hook/products/usePaginationHandler";
import ProductSizeFilter from "@components/products/list/ProductSizeFilter";
import { numberCheck } from "@common/NumberCheck";
import { ProductsApi } from "@api/products";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSearchAllListQuery } from "@hook/products/useSearchAllListQuery";

const ProductsList = ({
  products,
  product,
  productFilters,
  fetchProduct,
  updateProductFilters,
  updateProductCategory,
  isLoading,
  isLoaded,
  banners,
  dummyList,
  loading,
  userDevice,
  disableRouting,
  fixedCategory,
  seoData,
  initialPage = 1,
}) => {
  const { prodLeftBtm } = useBannerQuery();
  const router = useRouter();
  const queryClient = useQueryClient();

  const getEnameFromPath = () => {
    if (!router.isReady) return "";

    const { slug } = router.query;
    return slug || "";
  };

  const ename = getEnameFromPath();

  // 리스트 타입
  const [viewType, setViewType] = useState("");
  // 상품 리스트
  const [productList, setProductList] = useState([]);
  const [allProducts, setAllProducts] = useState(products?.items || []); //전체 상품 데이터
  const [filteredProducts, setFilteredProducts] = useState(
    products?.items || []
  ); //필터링된 데이터

  // 여기에 isSearching 함수 추가
  const isSearching = () => {
    // 기본 검색 파라미터와 다른 경우 검색 중으로 간주
    return (
      searchParams.unit.garo !== "0" ||
      searchParams.unit.sero !== "0" ||
      searchParams.unit.high !== "0" ||
      searchParams.unit.erange !== "0"
    );
  };

  //상품 검색
  const [searchParams, setSearchParams] = useState({
    unit: {
      garo: "0",
      sero: "0",
      high: "0",
      erange: "0",
    },
    page: initialPage,
    page_rows: 20,
  });

  // 현재 카테고리와 해시태그를 저장하기 위한 상태
  const [currentCategory, setCurrentCategory] = useState({
    code: null,
    hash: "",
  });

  // breadCrumbs
  const [categoryName, setCategoryName] = useState("");
  const [categorySizeSearch, setCategorySizeSearch] = useState("");
  const [categoryHash, setCategoryHash] = useState([]);

  // 로그인 모달
  const [openLoginModal, setOpenLoginModal] = useState(false);

  //페이지네이션
  const [page, setPage] = useState(initialPage);

  // URL에서 슬러그가 숫자인지 확인
  const isNumericSlug =
    router.isReady && router.query.slug && numberCheck(router.query.slug);

  // 카테고리 상품 가져오기 Query
  const { data: categoryProductsData, isLoading: categoryLoading } = useQuery({
    queryKey: [
      "categoryProducts",
      currentCategory.code,
      currentCategory.hash,
      searchParams.page,
      searchParams.page_rows,
      searchParams.unit.garo,
      searchParams.unit.sero,
      searchParams.unit.high,
      searchParams.unit.erange,
    ],
    queryFn: async () => {
      // 카테고리 코드가 없거나 숫자 슬러그인 경우 쿼리 실행 중지
      if (!currentCategory.code || isNumericSlug)
        return { items: [], total_count: 0, total_page: 0 };

      isLoading(); // 로딩 상태 시작

      try {
        const body = {
          modes: "NewHashSet",
          code: currentCategory.code,
          hash: currentCategory.hash || "",
          unit: JSON.stringify(searchParams.unit),
          page: searchParams.page,
          page_rows: searchParams.page_rows,
        };
        const res = await ProductsApi(body);

        if (res?.Code === "0000") {
          // 응답 구조에 맞게 데이터 추출
          const items = res.Data.Rows?.data || [];
          const totalCount = res.Data.Rows?.total_count || 0;
          const totalPage = res.Data.Rows?.total_page || 0;

          isLoaded(); // 로딩 완료
          return { items, total_count: totalCount, total_page: totalPage };
        } else {
          isLoaded(); // 로딩 완료
          console.error("API 응답 오류:", res?.data);
          return { items: [], total_count: 0, total_page: 0 };
        }
      } catch (error) {
        console.error("카테고리 상품 로드 실패:", error);
        isLoaded(); // 로딩 완료
        return { items: [], total_count: 0, total_page: 0 };
      }
    },
    enabled: !!currentCategory.code && !isNumericSlug,
    onSuccess: (data) => {
      // 데이터 로드 후 처리
      setAllProducts(data.items || []);
      setFilteredProducts(data.items || []);

      // Redux 상태 업데이트
      fetchProduct(data.items || []);

      // 페이지네이션 업데이트 - 현재 URL의 페이지 번호 유지
      createPagination();

      // 검색 후 결과가 나오면 페이지 번호 유지
      const path = router.asPath.split("?")[0];
      const pathSegments = path.split("/").filter((segment) => segment !== "");

      // 마지막 세그먼트가 숫자인지 확인 (페이지 번호)
      const lastSegment = pathSegments[pathSegments.length - 1];
      if (!isNaN(parseInt(lastSegment, 10))) {
        const pageFromUrl = parseInt(lastSegment, 10);
        if (pageFromUrl > 0 && pageFromUrl <= data.total_page) {
          // URL의 페이지 번호가 유효하면 해당 페이지로 설정
          setPage(pageFromUrl);
          setSearchParams((prev) => ({
            ...prev,
            page: pageFromUrl,
          }));
        }
      }
    },
    // 검색 조건이 변경되어도 현재 페이지의 쿼리 캐시를 무효화하지 않도록 설정
    // 이렇게 하면 검색 중 페이지 간 이동 시 검색 상태가 유지됨
    keepPreviousData: true,
  });

  // 상품 데이터를 가져오는 함수
  const { productsData, queryLoading } = useSearchAllListQuery({
    initialPage: initialPage,
    isNumericSlug,
    queryPage: page,
  });

  const regularPaginationProps = usePaginationHandlerModified({
    products: {
      data: categoryProductsData?.items || [],
      total_count: categoryProductsData?.total_count || 0,
      total_page: categoryProductsData?.total_page || 0,
    },
    initialPage: page,
  });

  // productsData를 사용하는 부분은 이후에 정의
  const modifiedPaginationProps = usePaginationHandlerModified({
    products: productsData || { data: [], total_count: 0, total_page: 0 },
    initialPage: page,
  });

  // 조건에 따라 적절한 핸들러 선택
  const {
    handleActive,
    getPaginationGroup,
    createPagination,
    currentPage,
    pagination,
    pages,
    limit,
    resetPage,
  } = isNumericSlug ? modifiedPaginationProps : regularPaginationProps;

  // =========== URL 관련 함수 ===============

  // URL 업데이트 함수 - 검색 상태를 유지하면서 페이지만 변경 (쿼리스트링 사용 안함)
  const updateUrlWithPage = (pageNumber) => {
    // 검색 중이면 URL 변경하지 않음
    if (isSearching()) {
      // 페이지 상태만 변경하고 URL은 변경하지 않음
      setPage(pageNumber);
      setSearchParams((prev) => ({
        ...prev,
        page: pageNumber,
      }));
      return;
    }

    const path = router.asPath.split("?")[0];
    const pathSegments = path.split("/").filter((segment) => segment !== "");

    if (pathSegments[0] === "products") {
      let newPath = "/products/";

      // 전체 상품 목록 페이지 (/products/ 또는 /products/2/)
      if (
        pathSegments.length === 1 ||
        (pathSegments.length === 2 && numberCheck(pathSegments[1]))
      ) {
        if (pageNumber === 1) {
          newPath = "/products/";
        } else {
          newPath = `/products/${pageNumber}/`;
        }
      }
      // 카테고리 페이지 (/products/[category]/ 또는 /products/[category]/2/)
      else if (pathSegments.length >= 2) {
        const category = pathSegments[1];

        // 카테고리+해시태그 형태인 경우
        if (
          pathSegments.length >= 3 &&
          pathSegments[2] &&
          !numberCheck(pathSegments[2])
        ) {
          const hash = pathSegments[2];
          if (pageNumber === 1) {
            newPath = `/products/${category}/${hash}/`;
          } else {
            newPath = `/products/${category}/${hash}/${pageNumber}/`;
          }
        }
        // 카테고리만 있는 경우
        else {
          if (pageNumber === 1) {
            newPath = `/products/${category}/`;
          } else {
            newPath = `/products/${category}/${pageNumber}/`;
          }
        }
      }

      const normalizePath = (p) => p.replace(/\/+$/, "") + "/";
      const normalizedNew = normalizePath(newPath);
      const normalizedCurrent = normalizePath(path);

      if (normalizedNew !== normalizedCurrent) {
        // 페이지 상태 업데이트
        setPage(pageNumber);
        setSearchParams((prev) => ({
          ...prev,
          page: pageNumber,
        }));

        // 실제 URL 변경 실행 - 페이지가 1이면 replace 사용
        if (pageNumber === 1) {
          router.replace(newPath, undefined, { shallow: true });
        } else {
          router.push(newPath, undefined, { shallow: true });
        }
      } else {
        console.log("URL 동일");
      }
    }
  };

  // 카테고리나 해시태그 변경 시 페이지 리셋 및 카테고리 정보 설정
  useEffect(() => {
    if (!router.isReady || !dummyList?.category) return;

    // URL에서 slug와 hash 확인
    const { slug, hash } = router.query;
    let categoryCode = null;
    let hashTag = hash || "";
    let pageNumber = initialPage;

    // 마지막 경로 세그먼트가 숫자인지 확인 (페이지 번호)
    const pathSegments = router.asPath
      .split("/")
      .filter((segment) => segment !== "");
    const lastSegment = pathSegments[pathSegments.length - 1];
    const isLastSegmentNumber =
      lastSegment && !isNaN(parseInt(lastSegment, 10));

    if (isLastSegmentNumber) {
      pageNumber = parseInt(lastSegment, 10);
    }

    // hash가 숫자인지 확인
    if (hash && numberCheck(hash)) {
      // hash가 숫자인 경우, 페이지 번호로 처리
      hashTag = ""; // 해시태그는 없음
    }

    // 카테고리 코드 결정
    if (disableRouting && fixedCategory) {
      categoryCode = fixedCategory;
    } else if (router.query.code) {
      categoryCode = router.query.code;
    } else if (isNumericSlug) {
      // 숫자 슬러그인 경우 카테고리 설정 건너뜀
      return;
    } else if (slug && dummyList?.category) {
      const matchedCategory = dummyList.category.find(
        (cat) => cat.ename === slug
      );
      if (matchedCategory) {
        categoryCode = matchedCategory.code;
      }
    }

    if (categoryCode) {
      // 카테고리 정보 설정
      const foundCategory = dummyList.category.find(
        (cat) => cat.code === categoryCode
      );

      if (foundCategory) {
        // 카테고리 정보 설정
        setCategoryName(foundCategory.name || "");
        setCategorySizeSearch(foundCategory.search || "");

        // 해시태그 목록 설정
        const tempTags = foundCategory.hashTag || [];
        const safeHashTags = Array.isArray(tempTags) ? tempTags : [];
        setCategoryHash(safeHashTags);

        // 이전 카테고리/해시태그와 비교하여 변경됐는지 확인
        const prevCategory = currentCategory.code;
        const prevHash = currentCategory.hash;

        // 카테고리나 해시태그가 변경된 경우에만 데이터 초기화
        if (prevCategory !== categoryCode || prevHash !== hashTag) {
          // 페이지 번호 유지 - 검색 조건 변경 시에도 현재 페이지 유지
          if (isLastSegmentNumber) {
            // 페이지 번호가 URL에 있으면 그 번호로 설정
            setPage(pageNumber);
            setSearchParams((prev) => ({
              ...prev,
              page: pageNumber,
            }));
          } else if (!hash || !numberCheck(hash)) {
            // 페이지 번호가 없고 해시태그도 숫자가 아닌 경우에만 페이지 초기화
            resetPage(1);
            setPage(1);
            setSearchParams((prev) => ({
              ...prev,
              page: 1,
            }));
          }

          // 캐시된 상품 데이터 무효화 (새로운 요청 보장)
          queryClient.invalidateQueries(["categoryProducts"]);
        }

        // 현재 카테고리 정보 설정 - 페이지 번호와 관계없이 항상 업데이트
        setCurrentCategory({
          code: categoryCode,
          hash: hashTag,
        });

        // Redux 상태 업데이트
        updateProductCategory(dummyList.category);
        updateProductFilters({ hash: hashTag });
      }
    } else if (dummyList?.category) {
      // 기존 리다이렉트 로직
      // if (!disableRouting && !isNumericSlug && !router.query.subTitle) {
      //   router.replace("/products/No-Tape-Box/", undefined, { shallow: true });
      // }
    }
  }, [
    router.asPath,
    router.query,
    dummyList,
    router.isReady,
    disableRouting,
    fixedCategory,
    isNumericSlug,
  ]);

  // 페이지 변경 처리 함수
  const handlePageChange = (newPage) => {
    // 유효한 페이지 번호인지 확인
    const maxPages = isNumericSlug
      ? modifiedPaginationProps.pages
      : regularPaginationProps.pages;

    if (newPage === currentPage) {
      return;
    }

    if (newPage <= 0 || newPage > maxPages) {
      return;
    }

    window.scrollTo(0, 520);

    // 검색 중일 때는 URL 변경 없이 페이지 상태만 업데이트
    if (isSearching()) {
      setPage(newPage);
      setSearchParams((prev) => ({
        ...prev,
        page: newPage,
      }));
    } else {
      // 검색 중이 아닐 때만 URL 업데이트
      updateUrlWithPage(newPage);
    }

    // 데이터 요청
    if (isNumericSlug) {
      queryClient.invalidateQueries({
        queryKey: ["products", newPage],
        refetchActive: true,
      });
    } else {
      queryClient.invalidateQueries({
        queryKey: [
          "categoryProducts",
          currentCategory.code,
          currentCategory.hash,
          newPage,
        ],
        refetchActive: true,
      });
    }
  };

  // URL에서 페이지 정보를 추출하여 동기화 (검색 중이면 URL 유지)
  const syncPageFromUrl = () => {
    if (!router.isReady) return;

    // 검색 중이면 URL에서 페이지 동기화하지 않음
    if (isSearching()) {
      return;
    }

    // URL 경로 분석
    const path = router.asPath.split("?")[0];
    const pathSegments = path.split("/").filter((segment) => segment !== "");

    // 페이지 번호 확인
    let pageFromUrl = 1; // 기본값

    if (isNumericSlug && pathSegments.length > 1) {
      // /products/2/ 형태
      pageFromUrl = parseInt(pathSegments[1], 10);
    } else if (pathSegments.length >= 3) {
      // 카테고리 또는 해시태그 페이지의 마지막 세그먼트가 숫자인지 확인
      const lastSegment = pathSegments[pathSegments.length - 1];
      if (!isNaN(parseInt(lastSegment, 10))) {
        pageFromUrl = parseInt(lastSegment, 10);
      }
    }

    // 현재 상태와 URL의 페이지 번호가 다른 경우에만 업데이트
    if (pageFromUrl && pageFromUrl !== page) {
      setPage(pageFromUrl);
      setSearchParams((prev) => ({
        ...prev,
        page: pageFromUrl,
      }));
    }
  };

  // URL 변경 시 페이지 동기화 (검색 중이 아닐 때만)
  useEffect(() => {
    if (isSearching()) {
      return;
    }
    syncPageFromUrl();
  }, [router.asPath, router.isReady]);

  // 페이지 변경 시 상품 목록 업데이트 - 일반 카테고리 뷰만 해당
  useEffect(() => {
    if (!isNumericSlug) {
      if (categoryProductsData?.items?.length > 0) {
        const startIdx = (currentPage - 1) * limit;
        const endIdx = startIdx + limit;
        const pagedProducts = categoryProductsData.items.slice(
          startIdx,
          endIdx
        );
        setProductList(pagedProducts);
      } else if (filteredProducts.length > 0) {
        const startIdx = (currentPage - 1) * limit;
        const endIdx = startIdx + limit;
        const pagedProducts = filteredProducts.slice(startIdx, endIdx);
        setProductList(pagedProducts);
      }
    }
  }, [
    currentPage,
    filteredProducts,
    categoryProductsData,
    limit,
    isNumericSlug,
  ]);

  // 비회원 바로 구매 모달 오픈
  const handleLoginModal = () => {
    setOpenLoginModal((prev) => !prev);
  };

  const handleListViewType = (type) => {
    if (viewType === type) {
      return;
    }
    localStorage.setItem("P_viewType", type);
    setViewType(type);
  };

  // 초기 로드 및 뷰 타입 설정
  useEffect(() => {
    if (!router.isReady) return;
    if (userDevice === "mobile") {
      setViewType("grid");
      setViewType(localStorage.setItem("P_viewType", "grid"));
    } else if (localStorage.getItem("P_viewType")) {
      setViewType(localStorage.getItem("P_viewType"));
    } else if (router.query.code == "13" || router.query.code == "11") {
      setViewType("grid");
    } else {
      setViewType("list");
    }
  }, [router.isReady, userDevice]);

  // 바로 구매하기
  const purchaseDirect = (product) => () => {
    sessionStorage.setItem(
      "directOrder",
      JSON.stringify([{ ...product, cnt: 1 }])
    );
    if (!getCookie("token") && !openLoginModal) {
      handleLoginModal();
      return;
    } else {
      document.body.style.removeProperty("overflow");
      sessionStorage.setItem(
        "directOrder",
        JSON.stringify([{ ...product, cnt: 1 }])
      );
      router.push({
        pathname: "/checkout",
        query: {
          type: "direct",
        },
      });
    }
  };

  // 필터링 적용
  useEffect(() => {
    if (!isNumericSlug) {
      // 숫자 슬러그가 아닌 경우에만 필터링 적용
      let filtered = [...allProducts];
      setFilteredProducts(filtered);
    }
  }, [allProducts, productFilters, isNumericSlug]);

  // 숫자 슬러그일 때 페이지 설정
  useEffect(() => {
    if (router.isReady && isNumericSlug) {
      const pageNumber = parseInt(router.query.slug, 10);
      if (pageNumber > 0 && pageNumber !== page) {
        // 상태 업데이트
        setPage(pageNumber);
        setSearchParams((prev) => ({
          ...prev,
          page: pageNumber,
        }));
      }
    }
  }, [router.isReady, router.query.slug, isNumericSlug]);

  const modalScrollHook = modalOverflowHook(openLoginModal);

  // 페이지네이션 버튼 기능에 필요한 NoticePagination 컴포넌트에 전달할 핸들러
  const customHandleActive = (pageNumber) => {
    // 페이지 변경 처리 - 검색 조건 유지하면서 페이지 이동
    if (pageNumber !== page) {
      // 현재 페이지와 다른 경우에만 처리
      try {
        // 스크롤 이동
        window.scrollTo(0, 520);

        // 검색 중일 때는 URL 변경 없이 페이지 상태만 업데이트
        if (isSearching()) {
          setPage(pageNumber);
          setSearchParams((prev) => ({
            ...prev,
            page: pageNumber,
          }));
        } else {
          // 검색 중이 아닐 때만 URL 업데이트
          const path = router.asPath.split("?")[0];
          const pathSegments = path
            .split("/")
            .filter((segment) => segment !== "");

          let newPath = "";

          if (isNumericSlug) {
            // 전체 상품 목록 페이지 형태
            newPath =
              pageNumber === 1 ? "/products/" : `/products/${pageNumber}/`;
          } else if (pathSegments.length >= 2) {
            // 현재 URL 분석
            const category = pathSegments[1];

            // 카테고리+해시태그 형태인 경우
            if (
              pathSegments.length >= 3 &&
              pathSegments[2] &&
              !numberCheck(pathSegments[2])
            ) {
              const hash = pathSegments[2];
              newPath =
                pageNumber === 1
                  ? `/products/${category}/${hash}/`
                  : `/products/${category}/${hash}/${pageNumber}/`;
            } else {
              // 카테고리만 있는 경우
              newPath =
                pageNumber === 1
                  ? `/products/${category}/`
                  : `/products/${category}/${pageNumber}/`;
            }
          }

          // 페이지 상태 업데이트
          setPage(pageNumber);
          setSearchParams((prev) => ({
            ...prev,
            page: pageNumber,
          }));

          // URL 변경
          if (pageNumber === 1) {
            router.replace(newPath, undefined, { shallow: true });
          } else {
            router.push(newPath, undefined, { shallow: true });
          }
        }

        // 데이터 요청
        if (isNumericSlug) {
          queryClient.invalidateQueries({
            queryKey: ["products", pageNumber],
            refetchActive: true,
          });
        } else {
          queryClient.invalidateQueries({
            queryKey: [
              "categoryProducts",
              currentCategory.code,
              currentCategory.hash,
              pageNumber,
            ],
            refetchActive: true,
          });
        }
      } catch (error) {
        console.error("페이지 이동 중 오류:", error);
      }
    }
  };

  return (
    <Suspense>
      {isNumericSlug ? (
        <>
          <Layout
            pageTitle={seoData?.name}
            pageDesc={seoData?.description}
            pageImg={seoData?.image}
            pageKeyword={seoData?.keywords}
            noBreadcrumb="d-none"
          >
            <section className="container mt-15 position-relative">
              {dummyList?.category && <CategorySlider />}
            </section>
            <div className={"container mt-40"}>
              <P.ProductsGrid>
                {productsData?.data?.map((item, i) => (
                  <div key={i}>
                    <SingleProduct product={item} />
                  </div>
                ))}
              </P.ProductsGrid>

              {productsData?.data?.length > 0 && (
                <div className="d-flex w-100 justify-content-center mt-30 mb-30">
                  <NoticePagination
                    prev={() => handlePageChange(page - 1)}
                    currentPage={page}
                    getPaginationGroup={getPaginationGroup()}
                    next={() => handlePageChange(page + 1)}
                    pages={pages}
                    nextEnd={() => handlePageChange(pages)}
                    prevStart={() => handlePageChange(1)}
                    handleActive={customHandleActive}
                  />
                  {pagination.length > 1 && (
                    <li className="d-none d-md-flex align-items-center ml-10">
                      {page} / {pages}
                    </li>
                  )}
                </div>
              )}
            </div>
          </Layout>
        </>
      ) : (
        // 일반 카테고리 페이지인 경우 기존 레이아웃
        <Layout
          noBreadcrumb="d-none"
          parent={"홈"}
          sub={"상품구매"}
          subTitle={seoData?.name}
          subChild={
            router.query.hash && numberCheck(router.query.hash)
              ? ""
              : router.query.hash
          }
          pageTitle={seoData?.name}
          pageDesc={seoData?.description}
          pageImg={seoData?.image}
          pageKeyword={seoData?.keywords}
        >
          <section className="container mt-15 position-relative">
            {dummyList?.category && <CategorySlider />}
          </section>
          <P.Container className="mt-50 mb-50">
            <div className="container mb-30">
              {/* 모바일 헤더 */}
              <div className="m_title">
                <Breadcrumb2
                  categoryName={categoryName}
                  categoryHash={categoryHash}
                  hash={router.query.hash}
                />
              </div>
              <div className={"row"}>
                {/* 좌측 메뉴 */}
                <P.StickyMenu
                  className={"col-lg-1-5 primary-sidebar sticky-sidebar"}
                >
                  <div className="sidebar-widget widget-category-2 mb-30">
                    <h5 className="section-title style-1 mb-30">상세 분류</h5>
                    <Tags
                      categoryHash={categoryHash}
                      categoryName={categoryName}
                    />
                  </div>
                  <P.MenuBanner className="banner-img fadeIn mb-lg-0 animated">
                    {prodLeftBtm &&
                      prodLeftBtm.length > 0 &&
                      prodLeftBtm.slice(0, 4).map((el, i) => (
                        <Link href={el.link_url} key={i}>
                          <a target={el.new_win === "Y" ? "_blank" : "_self"}>
                            <img src={el.P_FileUrl} alt={el.img_alt} />
                          </a>
                        </Link>
                      ))}
                  </P.MenuBanner>
                </P.StickyMenu>

                {/*  목록 */}
                <div className={"col-lg-4-5 mb-30"}>
                  <div className="p_title">
                    <div className="breadcrumb">
                      <Breadcrumb2
                        categoryName={categoryName}
                        categoryHash={categoryHash}
                        hash={router.query.hash}
                        ename={ename}
                      />
                    </div>
                    <P.ListViewTypeWrapper>
                      <P.ListViewSelectBox
                        listViewType={viewType ? viewType : "grid"}
                      >
                        <span
                          className={
                            !viewType || viewType === "grid" ? "selected" : ""
                          }
                          onClick={() => handleListViewType("grid")}
                        >
                          <i className="fi-rs-grid" />
                          {/* 그리드형 */}
                        </span>
                        <span
                          className={
                            viewType && viewType === "list" ? "selected" : ""
                          }
                          onClick={() => handleListViewType("list")}
                        >
                          <i className="fi-rs-list" />
                          {/* 리스트형 */}
                        </span>
                      </P.ListViewSelectBox>
                    </P.ListViewTypeWrapper>
                  </div>
                  <P.FilterWrapper className="">
                    <span className="cnt">
                      <strong className="text-brand">
                        {categoryProductsData?.total_count || 0}
                      </strong>
                      개의 상품
                    </span>
                    <div className="filter">
                      {categorySizeSearch !== "N" && (
                        <ProductSizeFilter
                          categorySizeSearch={categorySizeSearch}
                          allProducts={allProducts} // 전체 상품
                          setAllProducts={setAllProducts}
                          setFilteredProducts={setFilteredProducts} // 필터 결과 저장
                          selectedCategory={
                            router.query?.code || currentCategory.code
                          } // 카테고리 코드
                          createPagination={createPagination} // 페이지네이션 함수 전달
                          searchParams={searchParams}
                          setSearchParams={setSearchParams}
                          setPage={setPage}
                          currentCategory={currentCategory}
                          resetPagination={resetPage}
                        />
                      )}
                    </div>
                  </P.FilterWrapper>
                  {(!viewType || viewType === "grid") && (
                    <P.ProductsGrid>
                      {categoryProductsData?.items?.length === 0 && (
                        <P.ProductsSignWrapper style={{ gridColumn: "span 4" }}>
                          <h4>
                            찾으시는 상품이 없다면 우측 하단의 채널톡으로 문의를
                            넣어주시거나
                          </h4>
                          <h4>맞춤제작 서비스를 이용해보세요.</h4>
                          <a
                            className="btn"
                            href="/customizing/customizing-products/"
                          >
                            맞춤제작 바로가기
                          </a>
                        </P.ProductsSignWrapper>
                      )}
                      {categoryProductsData?.items?.map((item, i) => (
                        <div key={i}>
                          <SingleProduct
                            product={item}
                            dummyList={dummyList}
                            listViewType={viewType ? viewType : "grid"}
                          />
                        </div>
                      ))}
                    </P.ProductsGrid>
                  )}
                  {viewType && viewType === "list" && (
                    <P.ProductsList>
                      {categoryProductsData?.items?.length === 0 && (
                        <P.ProductsSignWrapper>
                          <h4>
                            찾으시는 상품이 없다면 우측 하단의 채널톡으로 문의를
                            넣어주시거나
                          </h4>
                          <h4>맞춤제작 서비스를 이용해보세요.</h4>
                          <a
                            className="btn"
                            href="/customizing/customizing-products/"
                          >
                            맞춤제작 바로가기
                          </a>
                        </P.ProductsSignWrapper>
                      )}
                      {categoryProductsData &&
                        categoryProductsData?.items?.length > 0 && (
                          <TableTypeList
                            productList={categoryProductsData.items}
                            dummyList={dummyList}
                            purchaseDirect={purchaseDirect}
                          />
                        )}
                    </P.ProductsList>
                  )}
                  {categoryProductsData &&
                    categoryProductsData?.items.length > 0 && (
                      <div className="d-flex w-100 justify-content-center mt-30">
                        <NoticePagination
                          prev={() => handlePageChange(page - 1)}
                          currentPage={page}
                          getPaginationGroup={getPaginationGroup()}
                          next={() => handlePageChange(page + 1)}
                          pages={pages}
                          nextEnd={() => handlePageChange(pages)}
                          prevStart={() => handlePageChange(1)}
                          handleActive={customHandleActive}
                        />
                        {pagination.length > 1 && (
                          <li className="d-none d-md-flex align-items-center ml-10">
                            {currentPage} / {pages}
                          </li>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </P.Container>
        </Layout>
      )}
      {openLoginModal && (
        <RequestLoginModal
          handleLoginModal={handleLoginModal}
          openLoginModal={openLoginModal}
          purchaseDirect={purchaseDirect}
          product={JSON.parse(sessionStorage.getItem("directOrder"))[0]}
          cnt={1}
        />
      )}
    </Suspense>
  );
};

const mapStateToProps = (state) => ({
  products: state.products,
  productFilters: state.productFilters,
  banners: state.banners,
  dummyList: state.dummyList,
  loading: state.loading.loading,
});

const mapDidpatchToProps = {
  fetchProduct,
  updateProductFilters,
  updateProductCategory,
  isLoading,
  isLoaded,
};

export default connect(mapStateToProps, mapDidpatchToProps)(ProductsList);
